import { useAccount } from '@azure/msal-react';
import { useSearchParams } from 'react-router-dom';
import { useUserRole } from 'src/provider/UserRoleProvider';

export function useApiHeaders() {
  const account = useAccount();
  const userRole = useUserRole();
  const [searchParams] = useSearchParams();
  const countryCode = String(searchParams.get('countryCode'));
  const companyCode = String(searchParams.get('companyCode'));

  return {
    'IM-CompanyCode': companyCode,
    'IM-CountryCode': countryCode,
    'IM-RoleId': userRole.role.find((role) => role !== 120)?.toString(),
    'IM-UserEmail': account?.username.toLowerCase(),
  };
}
